import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  container: {
    paddingTop: 64,
    paddingBottom: 36,
    paddingHorizontal: 16
  },
  main: {
    display: 'flex',
    alignItems: 'center'
  },
  continueButton: {
    marginTop: 64
  },
  backButton: {
    marginTop: 16
  },
  descriptionText: {
    fontSize: 16,
    marginTop: 24,
    maxWidth: 292,
    lineHeight: 18,
    textAlign: 'center'
  },
  title: {
    fontSize: 24,
    maxWidth: 314,
    marginTop: 24,
    lineHeight: 28,
    letterSpacing: 0.2,
    fontWeight: 'bold',
    textAlign: 'center'
  }
})

export default styles
